import {
  SourceUsageChartPoint,
  SourceUsageChartSeriesItem,
} from "../types";

const Y_AXIS_PADDING = 5;
const Y_AXIS_MIN = 0;
const Y_AXIS_MAX = 100;
const Y_AXIS_MIN_SPAN = 10;
const Y_AXIS_ROUND_STEP = 5;

function roundUpToStep(value: number, step: number): number {
  return Math.ceil(value / step) * step;
}

/**
 * Builds a Y-axis domain for source usage charts based on actual series values.
 * Keeps the lower bound at 0 and caps the upper bound at 100%.
 */
export function getSourceUsageYAxisDomain(
  data: SourceUsageChartPoint[],
  series: SourceUsageChartSeriesItem[]
): [number, number] {
  const values: number[] = [];

  for (const point of data) {
    for (const { dataKey } of series) {
      const value = point[dataKey];
      if (typeof value === "number" && !Number.isNaN(value)) {
        values.push(value);
      }
    }
  }

  if (values.length === 0) {
    return [Y_AXIS_MIN, Y_AXIS_MAX];
  }

  const maxValue = Math.max(...values);

  if (maxValue === 0) {
    return [Y_AXIS_MIN, Y_AXIS_MAX];
  }

  const paddedMax = Math.min(Y_AXIS_MAX, maxValue + Y_AXIS_PADDING);
  const roundedMax = roundUpToStep(paddedMax, Y_AXIS_ROUND_STEP);
  const upperBound = Math.min(
    Y_AXIS_MAX,
    Math.max(Y_AXIS_MIN_SPAN, roundedMax)
  );

  return [Y_AXIS_MIN, upperBound];
}
